import MappaCastelli from "./MappaCastelli";

const places = [
  {
    time: "30'",
    name: "Roma Termini",
    text: "Treno diretto dalla stazione di Marino, perfetto per visitare la Capitale in giornata.",
  },
  {
    time: "5'",
    name: "Castel Gandolfo",
    text: "Lago e residenza estiva papale a 5 min di treno o 10 in macchina/Cotral.",
  },
  {
    time: "20'",
    name: "Lago di Nemi",
    text: "Famoso per le fragoline di bosco, panorami mozzafiato e borgo caratteristico.",
  },
  {
    time: "0'",
    name: "Enogastronomia",
    text: "Fraschette storiche, cantine aperte e boschi secolari subito fuori dal portone.",
  },
];

export default function Posizione() {
  return (
    <section id="posizione" className="py-24 px-6 border-b border-[#2a2825] bg-[#181614]" data-testid="posizione-section">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-16">
          <p className="font-mono-tag text-xs uppercase tracking-widest text-[#c9944a] mb-3">Hub Castelli Romani</p>
          <h2 className="text-3xl sm:text-5xl font-display">Tutto a portata di mano, senza lo stress della città.</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {places.map((p, i) => (
            <div key={i} className="p-6 bg-[#121110] border border-[#2a2825]" data-testid={`place-card-${i}`}>
              <div className="text-4xl font-display text-[#c9944a] mb-2">{p.time}</div>
              <div className="text-xs uppercase font-mono-tag text-[#f4efe8] mb-2 font-semibold">{p.name}</div>
              <p className="text-xs text-[#a8a095]">{p.text}</p>
            </div>
          ))}
        </div>

        <MappaCastelli />
      </div>
    </section>
  );
}
